import Vue from 'vue'
import FullCalendar from 'vue-full-calendar'
import 'fullcalendar/dist/locale/ja'
Vue.use(FullCalendar)


// WEBPACK FOOTER //
// ./resources/js/plugins/full-calendar.js